import { useEffect, useState } from "react";
import { api, frDate, openPdf, downloadPdf } from "../lib/api";
import PageHeader from "../components/PageHeader";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Badge } from "../components/ui/badge";
import { Search, IdCard, Download, User } from "lucide-react";

export default function CartesMembres() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/members").then((r) => setRows(r.data)).catch(() => {});
  }, []);

  const filtered = rows.filter((m) => {
    if (!q) return true;
    return `${m.first_name} ${m.last_name} ${m.member_number}`.toLowerCase().includes(q.toLowerCase());
  });

  return (
    <div data-testid="cartes-membres-page">
      <PageHeader
        eyebrow="Identité"
        title="Cartes de membre"
        description="Générez une carte de membre officielle (recto-verso, avec photo) au format PDF pour chaque adhérent."
      />

      <div className="bg-white border border-brand-border rounded-xl p-3 mb-6 flex items-center gap-2">
        <Search size={16} className="text-gray-400 ml-2" />
        <Input
          data-testid="search-card-input"
          placeholder="Rechercher un membre..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="border-0 focus-visible:ring-0 shadow-none"
        />
      </div>

      {filtered.length === 0 ? (
        <div className="bg-white border border-brand-border rounded-xl p-10 text-center text-gray-400">
          Aucun membre trouvé. Créez d'abord des membres dans la section Membres.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((m) => (
            <div key={m.id} className="bg-white border border-brand-border rounded-xl overflow-hidden hover:shadow-md transition-shadow">
              {/* Carte preview */}
              <div className="relative bg-brand-navy text-white p-4 h-44">
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-brand-orange" />
                <div className="flex items-start gap-3 pt-1">
                  <img
                    src="https://customer-assets.emergentagent.com/job_0233820f-1364-4d66-83e8-80e343bbfaff/artifacts/oxpkfugr_Action%20Impact%20Jeunesse%20%283%29.png"
                    className="h-8 w-8 object-contain bg-white rounded-full p-0.5"
                    alt=""
                  />
                  <div className="leading-tight">
                    <div className="font-serif text-sm">Action Impact Jeunesse</div>
                    <div className="small-caps text-[9px] text-white/60">Carte de membre</div>
                  </div>
                  <div className="ml-auto">
                    {m.photo_base64 ? (
                      <img src={m.photo_base64} alt="" className="w-14 h-16 object-cover rounded-md border border-white/30" />
                    ) : (
                      <div className="w-14 h-16 rounded-md bg-white/10 flex items-center justify-center">
                        <User size={20} className="text-white/60" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="absolute bottom-3 left-4 right-4">
                  <div className="font-serif text-lg leading-tight truncate uppercase">{m.first_name} {m.last_name}</div>
                  <div className="text-[10px] text-white/60">N° {m.member_number} · Depuis {frDate(m.join_date)}</div>
                  <Badge className="bg-brand-green text-white mt-2 text-[10px] px-2 py-0.5">MEMBRE ACTIF</Badge>
                </div>
              </div>

              <div className="p-4 flex items-center gap-2">
                <Button data-testid={`view-card-${m.id}`} size="sm" variant="outline" className="flex-1" onClick={() => openPdf(`/members/${m.id}/card-pdf`)}>
                  <IdCard size={14} className="mr-1" /> Aperçu
                </Button>
                <Button size="sm" className="flex-1 bg-brand-orange hover:bg-[#D04A06] text-white" onClick={() => downloadPdf(`/members/${m.id}/card-pdf`, `carte-${m.first_name}-${m.last_name}.pdf`)}>
                  <Download size={14} className="mr-1" /> Télécharger
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
